import el from "@cypherpotato/el";

export function DefinitionList(...args) {
    return el("dl", ...args);
}

export function Definition(title, ...description) {
    return el.fragment(
        el("dt", title),
        el("dd", ...description)
    )
}